import { APP } from '../tokens';

const F = APP.fontFamily;

interface CoTTermPillProps {
  term: string;
}

export default function CoTTermPill({ term }: CoTTermPillProps) {
  return (
    <div
      style={{
        display: 'inline-flex',
        borderRadius: 10,
        paddingBlock: 2,
        paddingInline: 8,
        border: `1px solid ${APP.border}`,
      }}
    >
      <span
        style={{
          fontSize: 10,
          fontWeight: 400,
          color: APP.textDescription,
          lineHeight: '12px',
          fontFamily: F,
        }}
      >
        {term}
      </span>
    </div>
  );
}
